// Import all files in this directory and subdirectories
// This is needed for Webpack to bundle all TypeScript files
import cartItem from "./cart/CartItem";

const context = require.context('./', true, /(?<!\.d)\.ts$/);
context.keys().forEach(context);

// Normal imports
import PrestaGlobals from "./common/PrestaGlobals";
import CartItem from "./cart/CartItem";
import UnityHandler from "./designer/UnityHandler";
import Catalog from "./catalog/Catalog";
import CartProcessor from "./cart/CartProcessor";
import Boards from "./database/Boards";
import Edges from "./database/Edges";
import Fetcher from "./database/Fetcher";
import IParamScriptsRule from "./database/IParamScriptsRule";
import ParamScriptsProcessor from "./paramScript/ParamScriptsProcessor";
import CabinetZoneConfigurator from "./zones/CabinetZoneConfigurator";
import ComboBox from "./common/ComboBox";
import NumberUtils from "./common/NumberUtils";
import UCWindow from "./UCWindow";
import ICabinetResult from "./designer/ICabinetResult";

// TODO: Remove global variables
let uconScript: any = {}; // TODO: Type this
let paramScripts: IParamScriptsRule[] = [];
let cabinetResult: ICabinetResult | null = null;

let cartProcessor: CartProcessor | null = null;
let paramScriptProc: ParamScriptsProcessor | null = null;

let isParamScriptGenerating: boolean = false;
let addToCartFlag: boolean = false;

let recentDrag: boolean = false;

// draggable cart
let isResizing: boolean = false;
let startY: number = 0;
let startHeight: number = 0;

// cabinet zone configurator
let cabZoneConf: CabinetZoneConfigurator | null = null;

// catalog slide panel
const catalog: HTMLElement = document.querySelector<HTMLElement>('[data-id="catalog"]')!;

// cart slide panel
const cartPanel: HTMLElement = document.querySelector<HTMLElement>('[data-id="cart-panel"]')!;
const cartPanelTitle: HTMLElement = cartPanel.querySelector<HTMLElement>('[data-id="cart-panel-title"]')!;

// html UI templates
let templates: HTMLElement = document.querySelector<HTMLElement>('[data-id="templates"]')!;

const sessionStorageKeyName: string = "ucjson";
const sessionStorageStampKeyName: string = "ucjsonstamp";

// Add the service worker
window.addEventListener("load", function () {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/ServiceWorker.js");
  }
});

// Initialize the Unity WebGL app
UnityHandler.init(setShop);

// Initialite the database info
Boards.init("/boards?id_shop=" + PrestaGlobals.shopId);
Edges.init("/edges?id_shop=" + PrestaGlobals.shopId);
Catalog.init("/catalog");

// Opens the given tab content and closes all others
function openPage(evt: Event, pageName: string): void {
  // Remove trailing "-tab-button"
  pageName = pageName.replace("-tab-button", "");
  document.querySelectorAll<HTMLElement>(".tabcontent").forEach(tab => tab.style.display = "none");
  document.querySelectorAll<HTMLElement>(".tablinks").forEach(tab => tab.classList.remove("active"));
  document.getElementById(pageName)!.style.display = "block";
  if (evt) {
    (evt.currentTarget as HTMLElement).classList.add("active");
  }
}

// Add event listeners to tab buttons
document.querySelectorAll<HTMLElement>(".tablinks").forEach((tab: HTMLElement) => {
  tab.addEventListener("click", (event: MouseEvent) => {
    openPage(event, tab.getAttribute("data-id")!);
  });
});

function onDOMContentLoaded(): void
{
    updateDebugInfo();

    setButtonDisabledState("add-to-cart-btn", true);
    setButtonDisabledState("checkout-btn", true);
}

// Some debug info to show
function updateDebugInfo(): void
{
    const debugDiv = document.querySelector<Element>("#debug");

    let orientation: string;

    if (window.matchMedia("(orientation: portrait)").matches) {
        orientation = "portrait";
    } else {
        orientation = "landscape";
    }

    debugDiv!.innerHTML = "DPR:" + window.devicePixelRatio + " | " + window.innerWidth + "x" + window.innerHeight + " (" + orientation + ")";
}

// Update debug info on page load and window resize
document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
window.addEventListener("resize", updateDebugInfo);

// Hide the debug div by default
document.querySelector<HTMLElement>('#debug')!.style.display = "none";

// Stores the user's input (max 10 characters)
let userInput: string[] = [];

// Listen for key presses to detect debug sequence
document.addEventListener('keydown', function(event: KeyboardEvent): void {
    // Debug sequence handling
    let secretSequence: string = "DEBUG";

    // Add the key pressed to the userInput array
    userInput.push(event.key.toUpperCase());
    // Keep the length of the input to a maximum of 10 characters
    if (userInput.length > 10) {
        userInput.shift();  // Remove the oldest entry if the array gets too long
    }

    // Convert the last part of the userInput array to a string and check if it ends with the secret sequence
    let lastCharacters: string = userInput.slice(-secretSequence.length).join("");
    // If the last characters match the secret sequence, show the div
    if (lastCharacters === secretSequence) {
        const debugDiv: HTMLElement = document.querySelector<HTMLElement>('#debug')!;
        if (debugDiv!.style.display === "none") {
            debugDiv!.style.display = "block";
        } else {
            debugDiv!.style.display = "none";
        }
    }
});

const configurationContainer: HTMLElement = document.querySelector<HTMLElement>('[data-id="configuration"]')!;
configurationContainer.addEventListener('keydown', async function(event: KeyboardEvent): Promise<void> {
    // Shortcut for adding to session cart
    if (event.ctrlKey && event.key === 'Enter' && !event.shiftKey && !event.altKey && !event.metaKey) {
      event.preventDefault(); // Prevents default behavior like form submission
        await addToSessionCart();
    }
});

// Prevent the context menu from opening
const inputs: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('[data-id="order-name-input"]');
inputs.forEach((input: HTMLElement) => {
    input.addEventListener("click", (event: MouseEvent) => {
        event.stopPropagation();
    });
});

// Add event listeners to the cart buttons
document.querySelectorAll<HTMLButtonElement>('[data-id="add-to-cart-btn"]').forEach((button: HTMLButtonElement) => {
  button.addEventListener("click", async (event: MouseEvent) => {
    event.stopPropagation();
      await addToSessionCart();
  });
});

document.querySelectorAll<HTMLButtonElement>('[data-id="update-cart-btn"]').forEach((button: HTMLButtonElement) => {
  button.addEventListener("click", async (event: MouseEvent) => {
    event.stopPropagation();
      await updateSessionCart();
  });
});

document.querySelectorAll<HTMLButtonElement>('[data-id="empty-cart-btn"]').forEach((button: HTMLButtonElement) => {
  button.addEventListener("click", (event: MouseEvent) => {
    event.stopPropagation();
    confirmEmptyCart();
  });
});

document.querySelectorAll<HTMLButtonElement>('[data-id="checkout-btn"]').forEach((button: HTMLButtonElement) => {
  button.addEventListener("click", async (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    await checkout();
  });
});

// TODO: Is this line needed?
document.querySelector<HTMLElement>(".tablinks")!.click();

// Custom confirmation dialog window
const dialog: HTMLDialogElement = document.querySelector<HTMLDialogElement>('[data-id="confirmation-dialog"]')!;
if (dialog != null) {
  dialog.querySelector<HTMLFormElement>('form')!.addEventListener('submit', (event: Event) => {
      event.preventDefault();
  });

  dialog.querySelector<HTMLButtonElement>('[data-id="yes-btn"]')!.addEventListener('click', () => {
      dialog.querySelector<HTMLInputElement>('[data-id="return-value"]')!.value = "yes";
      dialog.close();
  });

  dialog.querySelector<HTMLButtonElement>('[data-id="no-btn"]')!.addEventListener('click', () => {
      dialog.querySelector<HTMLInputElement>('[data-id="return-value"]')!.value = "no";
      dialog.close();
  });
}

// Initialize combo boxes
document.querySelectorAll<HTMLElement>(".combo-wrapper").forEach(combo => {
    const myCB = new ComboBox();
    myCB.init(combo);
  });

// Update and return the current timestamp
function getTimestamp(): number {
  PrestaGlobals.savedTimestamp = Math.floor(new Date().getTime() / 1000);
  return PrestaGlobals.savedTimestamp;
}

type TShopInfo = {
  domain: string;
  shopFolder?: string;
  token: string;
  cdn?: string;
}

// Send the shop info to Unity
function setShop(): void {
  console.log("Setting shop...");
  if(UnityHandler.instance == null) {
    console.log("Unity instance is not ready in setShop!");
    return;
  }
    const shopInfo: TShopInfo = { domain: PrestaGlobals.shopURL, shopFolder: PrestaGlobals.virtualUri, token: "DummyToken", cdn: "cdn.ubercabinets.com" }; //TODO: hardcoded UC CDN
  UnityHandler.instance.SendMessage('WebInterface', 'SetShop', JSON.stringify(shopInfo));
}

// Send the uconScript to Unity
function setScript(): void {
  console.log("Setting script...");
  if(UnityHandler.instance == null) {
    console.log("setScript: Unity instance is not ready!");
    return;
  }

  console.log("===== BEGIN SENDING UCONSCRIPT TO UNITY =====")
  console.log(JSON.stringify(uconScript, null, 2));
  UnityHandler.instance.SendMessage('WebInterface', 'SetUConScript', JSON.stringify(uconScript, null, 2));
  console.log("===== END SENDING UCONSCRIPT TO UNITY =====")
}

// Send the parameters to Unity
function setParameters(): void {
  console.log("Setting parameters...");
  isParamScriptGenerating = true;

  if(UnityHandler.instance == null) {
    console.log("setParameters: Unity instance is not ready!");
    return;
  }

  var mergedObj: object = {}; // TODO: Maybe type this?
  if(paramScriptProc != null) {

    mergedObj = Object.assign(mergedObj, paramScriptProc.nameConf!.createParamScript());

    // loop through all items in paramScriptProc.sizeConf
    for(const key in paramScriptProc.sizeConf) {
      console.log("Setting size: " + key);
      mergedObj = Object.assign(mergedObj, paramScriptProc.sizeConf[key].createParamScript());
    }

    // loop through all items in paramScriptProc.matConf
    for(const key in paramScriptProc.matConf) {
      console.log("Setting material: " + key);
      mergedObj = Object.assign(mergedObj, paramScriptProc.matConf[key].createParamScript());
    }
  }

  console.log("===== BEGIN SENDING PARAMETERS TO UNITY =====")
  console.log(mergedObj);
  console.log(JSON.stringify(mergedObj, null, 2));
  UnityHandler.instance.SendMessage('WebInterface', 'SetStyleScript', JSON.stringify(mergedObj, null, 2));
  console.log("===== END SENDING PARAMETERS TO UNITY =====")
}

// Send "fit the cabinet to the screen" message to Unity
function fitToScreen(): void {
  // does nothing if myGameInstance is undefined
  UnityHandler.instance?.SendMessage('WebInterface', 'FitToScreen');
}

// TODO: Type the parameters
function restoreParamsFromCart(id_cabinet: number, pScript: any, uScript: any): void {
    if(uScript.length == 0) {
        alert("restoreParamsFromCart: uScript is empty!");
        return;
    }
    
    if(pScript.length == 0) {
        alert("restoreParamsFromCart: pScript is empty!");
        return;
    }

    // id_cabinet is the unique identifier of the cabinet in the cart
    // generated when the cabinet was added to the cart, it's a timestamp
    // here is how we restore it from the instant cart
    PrestaGlobals.savedTimestamp = id_cabinet;

    paramScripts = JSON.parse(JSON.stringify(pScript));
    paramScriptProc?.cleanup();

    paramScriptProc = new ParamScriptsProcessor(paramScripts, setParameters);
    showTabs(paramScriptProc.usedTabs); // will select the last tab

    // create a deep copy to the global uconScript & paramScripts
    uconScript = JSON.parse(JSON.stringify(uScript));
    updateUIWithScript();

    setScript();
    setParameters();
}

function clearCart(): void {
    const cartContainer: HTMLElement = document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="table"]')!;
    if (cartContainer != null) {
      [...cartContainer.children].forEach(child => {
          if (!child.hasAttribute("data-protected")) {
              cartContainer.removeChild(child);
          }
      });
    } else {
      console.log("Error: cartContainer is null!");
    }

    const cartContainerMobile: HTMLElement = document.querySelector<HTMLElement>('[data-id="cart-panel-mobile"] [data-id="list"]')!;
    if (cartContainerMobile != null) {
      [...cartContainerMobile.children].forEach(child => {
          if (!child.hasAttribute("data-protected")) {
              cartContainerMobile.removeChild(child);
          }
      });
    } else {
      console.log("Error: cartContainerMobile is null!");
    }
}

// Overlay remover
addEventListener("pageshow", () => {
  let overlay: HTMLElement | null = document.getElementById("loading-overlay");
  if (overlay) {
    overlay.remove();
  }
});

async function renameCartReferenceInPSCart(): Promise<void> {
    let orderNameInput = document.querySelector<HTMLInputElement>('[data-id="order-name-input"]');
    if (!orderNameInput) {
        console.error('Order name input could not be found in DOM.');
        return;
    }

    const orderName: string = orderNameInput.value?.trim();
    if (!orderName) {
        console.warn("Order name is empty, skipping saveCartReferenceInPSCart");
        return;
    }

    const cartId: number = PrestaGlobals.cartId;
    const payload = {
        cartId: cartId,
        orderName: orderName
    };

    try {
        const jsonResponse = await ajaxCall(payload, 'renamecartreference');
        console.log('Cart reference updated:', jsonResponse);
    } catch (error) {
        console.error('Failed to update cart reference:', error);
    }
}

async function checkout(): Promise<void> {
    await renameCartReferenceInPSCart();
    location.href = PrestaGlobals.cartURL;

    return;
}

function confirmDeleteItemFromCart(id: number): void {
    // easiest method because we don't have to deal stacked up dialog close event listeners
    document.body.classList.add("blur");
    // Delay the `confirm()` call to allow the blur to be rendered first
    setTimeout(() => {
        if (confirm("Biztosan törölni akarod ezt az elemet a kosárból?")) {
            ajax_deleteFromSessionCartSession(id);
        }
        document.body.classList.remove("blur");
    }, 200);  // Short delay (10ms) to allow the browser to apply the blur
}

function setButtonDisabledState(dataIdSelector: string, state: boolean): void {
    const buttons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('[data-id="' + dataIdSelector + '"]');

    if (buttons.length === 0) {
        alert("setButtonDisabledState: No " + dataIdSelector + " buttons found!");
        return;
    }

    buttons.forEach(btn => {  // Iterate over all found buttons
        if (btn) { // This check is now redundant but good practice to keep
            btn.disabled = state;
        }
    });
}

async function updateSessionCart():Promise<void> {
    clearCart();

    // use the existing timestamp as ID
    const cartItem: CartItem | null = createCartData(PrestaGlobals.savedTimestamp, "update");
    if(cartItem == null) {
        console.log("updateCart: cartItem is null!");
        return;
    }

    await ajax_getSessionCartSession();
    addToCartFlag = false;
}


async function ajaxCall(json:any, method:string): Promise<any> {
    const url: string = PrestaGlobals.virtualUri + "/index.php?fc=module&module=ubercart&controller=UCC&method="+method;
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: "payload="+JSON.stringify(json),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Return parsed AJAX response
        return await response.json();
    } catch (error) {
        console.error('getData error:', error);
        throw error;
    }
}

async function ajax_saveSessionCartToSession(JSONObj:any) {
    let stamp:string = [...Array(16)].map(() => Math.random().toString(36)[2]).join('')+"|"+Date.now();
    localStorage.setItem(sessionStorageStampKeyName, stamp);
    return await ajaxCall(JSONObj, "save");
}

async function emptySessionCart() {
    const JSONObj = await ajaxCall([], "save");
    clearCart();
    document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="item-count"]')!.innerHTML = "0";
    document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="grand-total"]')!.innerHTML = "0";
    await ajax_getSessionCartSession();
}

async function ajax_deleteFromSessionCartSession(id: number) {
    clearCart();
    let JSONObj:Array<CartItem> = await ajaxCall([], "load");
    JSONObj.forEach((item, index) => {
        if(item.id_cabinet == id) {
            JSONObj.splice(index,1);
        }
    });
    document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="item-count"]')!.innerHTML = "0";
    document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="grand-total"]')!.innerHTML = "0";
    const saveResponse = await ajaxCall(JSONObj, "save");
    await ajax_getSessionCartSession();
}

async function updateQtyInSessionCart(id: number, qty: number): Promise<void> {
    if(qty === 0) {
        await ajax_deleteFromSessionCartSession(id);
        return;
    }

    let JSONObj:Array<CartItem> = await ajaxCall([], "load");
    JSONObj.forEach((item, index) => {
        if(item.id_cabinet == id) {
            JSONObj[index].count = qty;
        }
    });

    await ajaxCall(JSONObj, "save");
    clearCart();
    document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="item-count"]')!.innerHTML = "0";
    document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="grand-total"]')!.innerHTML = "0";
    await ajax_getSessionCartSession();

    // Maintain the focus on the input field of the cart item
    focusOnCartItemCount(id);
}

async function getPriceForCartItem(cabinet:cartItem, JSONObj:Array<cartItem>):Promise<void> {
    const url: string = PrestaGlobals.virtualUri + "/index.php?fc=module&module=ubercart&controller=UCC&method=getprice";
    const f: Fetcher<CartItem> = new Fetcher<CartItem>(url, "POST");
    f.request("payload=" + JSON.stringify(cabinet), async (response: CartItem | null) => {
        if(response) {
            let responseCabinet = <CartItem>response;
            JSONObj.push(responseCabinet);
            await ajax_saveSessionCartToSession(JSONObj);
        }
        await ajax_getSessionCartSession();
        addToCartFlag = false;

        if (cabinet.cartAction === "add") {
            // if we added a new cabinet, we need to focus on the input field
            focusOnCartItemCount(cabinet.id_cabinet);
        }
    });
}

function focusOnCartItemCount(id: number): void {
    const cartItemCountInput: HTMLInputElement | null = cartPanel.querySelector<HTMLInputElement>('.cart-input[id="' + id + '"]');
    if(cartItemCountInput) {
        cartItemCountInput.focus();
        // Slide the cart panel out if it is currently in
        if(cartPanel.classList.contains("cart-panel-slide-out")) {
          cartPanel.classList.remove("cart-panel-slide-out");
          cartPanel.classList.add("cart-panel-slide-in");
        }
    }
}

async function addToSessionCart(): Promise<void> {
    if (!cartProcessor) {
        console.log("addToSessionCart: cartProcessor is null!");
        return;
    }

    if(isParamScriptGenerating) {
        console.log("generating in progress, deferring add to cart");
        addToCartFlag = true;
        return;
    }
    setButtonDisabledState("add-to-cart-btn", true);
    clearCart();

    const cartItem: CartItem | null = createCartData(getTimestamp(), "add");
    if(cartItem == null) {
        console.log("addToSessionCart: cartItem is null!");
        return;
    }

    // check weather the cabinet is already in the cart
    // if so, just increase the quantity
    const existingCab: CartItem | null = cartProcessor.findCabinetByContent(cartItem);
    if(existingCab != null) {
        await updateQtyInSessionCart(existingCab.id_cabinet, existingCab.count + 1);
        return;
    }

    cartItem.count = 1;

    let JSONObj:Array<CartItem> = await ajaxCall([], "load");
    let cabinetExists = false;
    JSONObj.forEach((item, index) => {
        if(item.id_cabinet == cartItem.id_cabinet) {
            JSONObj.splice(index,1);
        }
    });

    await getPriceForCartItem(cartItem, JSONObj);
}

async function ajax_getSessionCartSession(): Promise<void> {
    let sessionCartJSON = await ajaxCall([], "load");
    clearCart();
    cartProcessor = new CartProcessor(sessionCartJSON, PrestaGlobals.taxRate, restoreParamsFromCart, confirmDeleteItemFromCart, updateQtyInSessionCart, cartQuantityApplied);
    setButtonDisabledState("add-to-cart-btn", false);
    setButtonDisabledState("checkout-btn", cartProcessor.isCartEmpty());
}

function cartQuantityApplied(id: number): void {
  // Set focus on the first input of the configurator
  const firstInput: HTMLInputElement | null = document.querySelector<HTMLInputElement>('div[data-id="configuration"] input');
  if (firstInput) {
      firstInput.focus();
  }
}

function confirmEmptyCart(): void {
    document.body.classList.add("blur");
    // Delay the `confirm()` call to allow the blur to be rendered first
    setTimeout(() => {
        if (confirm("Biztosan törölni akarod a kosár teljes tartalmát?")) {
            emptySessionCart();
        }
        document.body.classList.remove("blur");
    }, 200);  // Short delay to allow the browser to apply the blur
}

// creates cart item for add to cart or update cart requests
function createCartData(cabinetID: number, cartAction: string): CartItem | null {
  if (paramScriptProc == null) {
    console.log("createCartData: paramScriptProc is null!");
    return null;
  }

  if (cabinetResult == null) {
    console.log("createCartData: cabinetResult is null!");
    return null;
  }

  const cartItem: CartItem = new CartItem();
  cartItem.id_cabinet = cabinetID;
  cartItem.cartAction = cartAction;
  cartItem.children = cabinetResult.Order;
  cartItem.Name = paramScriptProc.nameConf!.getName();

  if (cabinetResult.RootSize == null) {
    console.error("Cabinet result does not have RootSize!");
    return null;
  }
  cartItem.Dimensions = NumberUtils.formatNumber(cabinetResult.RootSize.Width)
      + "x" + NumberUtils.formatNumber(cabinetResult.RootSize.Height)
      + "x" + NumberUtils.formatNumber(cabinetResult.RootSize.Depth);

  // save the uconScript and paramScript to the cartItem
  cartItem.uconScript = uconScript;
  cartItem.descriptor.push( paramScriptProc.nameConf!.rule );

  for(const key in paramScriptProc.sizeConf) {
    cartItem.descriptor.push( paramScriptProc.sizeConf[key]!.rule );
  }

  for(const key in paramScriptProc.matConf) {
      cartItem.descriptor.push( paramScriptProc.matConf[key]!.rule );
  }

  return cartItem;
}

// this global uconScript is updated from the CartProcessor too
function updateUIWithScript(): void {
    cabZoneConf?.cleanup();

    // TODO: uconScript should be parsed in the future! Zone configuration must be provided by the param scripts!

    // comes from uconScript, not from paramScript
    if(uconScript.hasOwnProperty("Cabinet")) {
        document.querySelector<HTMLElement>('[data-id="zones"]')!.classList.remove("hidden");
        if(uconScript.Cabinet.CabinetFrame.hasOwnProperty("Content")) {
            cabZoneConf = new CabinetZoneConfigurator(uconScript.Cabinet.CabinetFrame.Content.StackZone.Children, uconScript.Cabinet.FrontZone.Fronts, setScript, setParameters);
        } else {
            cabZoneConf = new CabinetZoneConfigurator(uconScript.Cabinet.CabinetFrame, uconScript.Cabinet.FrontZone.Fronts, setScript, setParameters);
        }
    } else {
        document.querySelector<HTMLElement>('[data-id="zones"]')!.classList.add("hidden"); // hide zones
    }    
}

function openCatalog(): void {
  catalog.classList.remove("slide-out-animation");
  catalog.classList.add("slide-in-animation");
}

function closeCatalog(): void {
  catalog.classList.remove("slide-in-animation");
  catalog.classList.add("slide-out-animation");
}

function isCatalogOpen(): boolean {
  return catalog.classList.contains("slide-in-animation");
}

function updateProductCookie(product_id: string): void {
  const f: Fetcher = new Fetcher(PrestaGlobals.virtualUri + "/cookie?ajax=1", "POST");
  f.request("product_id=" + product_id, (response: Object | null) => {
    console.log("updateProductCookie response:");
    console.log(response);
  });
}

function preParseParamScripts(): void {
    if(Array.isArray(paramScripts) && paramScripts.length == 0) {
	    alert("There isn't paramscript for this product!");
        return;
    }
    // Rename "Size1D" to "Size". This may be removed after database cleanup.
    paramScripts.forEach((rule: IParamScriptsRule) => {
        if(rule.parameterType === "Size1D") {
            rule.parameterType = "Size";
        }
    });
    // Check for "Méret" parameters and convert to legacy style
    let sizeParams: IParamScriptsRule[] = paramScripts.filter((rule: IParamScriptsRule) => {
        return rule.parameterType === "Size" && rule.title === "Méret";
    });
    // Sort to "Width", "Height", "Depth" order
    sizeParams.sort((a: IParamScriptsRule, b: IParamScriptsRule) => {
        if (a.parameterName.endsWith("Width")) {
            return -1;
        } else if (a.parameterName.endsWith("Height")) {
            if (b.parameterName.endsWith("Width")) {
                return 1;
            } else {
                return -1;
            }
        } else if (a.parameterName.endsWith("Depth")) {
            return 1;
        }
        return 0;
    });
    if(sizeParams.length > 1) {
        // Alter the first size parameter to be the merged one, remove the others
        let mergedSize = sizeParams[0];
        let canMerge: boolean = true;
        if(sizeParams[0].parameterName.startsWith("Board")) {
            mergedSize.parameterName = "BoardSize";
        } else if(mergedSize.parameterName.startsWith("GeneralCabinet")) {
          if (sizeParams[1].parameterName === "GeneralCabinetHeight") {
            mergedSize.parameterName = "CabinetSize";
          } else if (sizeParams[1].parameterName === "ToeKickHeight") {
            mergedSize.parameterName = "ToeKickSize";
          }
        } else if(mergedSize.parameterName.startsWith("KitchenFull")) {
            if (sizeParams[1].parameterName === "KitchenBaseHeight") {
                mergedSize.parameterName = "KitchenBaseCabinetSize";
            } else if (sizeParams[1].parameterName === "KitchenWallHeight") {
                mergedSize.parameterName = "KitchenWallCabinetSize";
            } else if (sizeParams[1].parameterName === "KitchenHighHeight") {
                mergedSize.parameterName = "KitchenHighCabinetSize";
            }
        } else if(mergedSize.parameterName.startsWith("Desk")) {
          if (sizeParams[1].parameterName === "DeskHeight") {
            mergedSize.parameterName = "DeskSize";
          } else if (sizeParams[2].parameterName === "CornerDeskDepth") {
            mergedSize.parameterName = "CornerDeskSize";
          }
        } else if(mergedSize.parameterName.startsWith("TVStand")) {
            mergedSize.parameterName = "TVStandSize";
        } else if(mergedSize.parameterName.startsWith("WardrobeDouble")) {
            mergedSize.parameterName = "WardrobeDoubleSize";
        } else if(mergedSize.parameterName.startsWith("WardrobeTriple")) {
            mergedSize.parameterName = "WardrobeTripleSize";
        } else if(mergedSize.parameterName.startsWith("ConferenceTable")) {
            mergedSize.parameterName = "ConferenceTableSize";
        } else if(mergedSize.parameterName.startsWith("WorktopCorner")) {
            mergedSize.parameterName = "WorktopCornerSize";
        } else {
          canMerge = false;
        }

        if(canMerge) {
          mergedSize.title = "Méret";
          mergedSize.composite = 1;
          mergedSize.parameterType = sizeParams.length === 3 ? "Size3D" : ("Size2D");
          mergedSize.parameterValue += ", " + sizeParams[1].parameterValue;
          mergedSize.parameterProperty = "Size";
          if(sizeParams.length === 3) {
              mergedSize.parameterValue += ", " + sizeParams[2].parameterValue;
          }
          // Remove the other size parameters from paramScripts
          paramScripts = paramScripts.filter((rule: IParamScriptsRule) => {
              return !sizeParams.includes(rule) || rule === mergedSize;
          });
        }
    }
}

document.querySelector<HTMLButtonElement>('[data-id="catalog-btn"]')!.addEventListener("click", (event: MouseEvent) => {
  if(isCatalogOpen()) {
    closeCatalog();
  } else {
    openCatalog();
  }
});

// cart panel title is clickable to open/close the instant cart
cartPanelTitle.addEventListener("click", (event: MouseEvent) => {
    if(recentDrag) { // just finished a drag resize recently, so don't count this as click
        recentDrag = false;
        return;
    }
    if(cartPanel.classList.contains("cart-panel-slide-out")) {
        cartPanel.classList.remove("cart-panel-slide-out");
        cartPanel.classList.add("cart-panel-slide-in");
        cartPanelTitle.style.cursor = "ns-resize"; // change cursor to resize

        // If the cart panel height is less than 100px, reset it to the default height
        if (cartPanel.offsetHeight < 100) {
            cartPanel.style.height = "300px"; // Reset to default height
            cartPanel.style.setProperty('--inverseCartPanelHeight', `-270px`); // Reset the negative bottom value
        }
    } else {
        cartPanel.classList.remove("cart-panel-slide-in");
        cartPanel.classList.add("cart-panel-slide-out");
        cartPanelTitle.style.cursor = "pointer"; // change cursor to pointer
    }
});

cartPanelTitle.addEventListener("mousedown", (event: MouseEvent) => {

    if(cartPanel.classList.contains("cart-panel-slide-out")) {
        // we shouldn't resize when collapsed!
        return;
    }

    isResizing = true;
    startY = event.clientY;
    startHeight = cartPanel.offsetHeight;

    document.body.style.userSelect = "none";
});

document.addEventListener("mousemove", (event: MouseEvent) => {
    if ( ! isResizing) {
        return;
    }
    // Calculate the new height based on the mouse movement
    const deltaY: number = (startY - event.clientY);
    const newHeight: number = startHeight + deltaY;
    recentDrag = Math.abs(deltaY) > 10;
    // Enforce minimum and maximum height limits
    if (newHeight >= 30 && newHeight <= window.innerHeight * 0.80) {
        cartPanel.style.height = `${newHeight}px`;
        // this value is how big portion of the instant cart will be floated outside the view, a negative bottom for abs positioned div
        cartPanel.style.setProperty('--inverseCartPanelHeight', `-${newHeight - 30}px`);
    }
});

// Mouse up ends the resizing process
document.addEventListener("mouseup", (event: MouseEvent) => {
    if (isResizing) {
      isResizing = false;
      document.body.style.userSelect = ""; // Enable text selection again

      // If the cart panel height is less than 100px, reset it to the default height
      if (cartPanel.offsetHeight < 100) {
        cartPanel.classList.remove("cart-panel-slide-in");
        cartPanel.classList.add("cart-panel-slide-out");
        cartPanelTitle.style.cursor = "pointer"; // change cursor to pointer
      }
    }
});

// designer sends cabinet result
(window as UCWindow).UCOrderReceived = function(result: any) {
  console.log("UCOrderReceived, storing result...");
  cabinetResult = JSON.parse(result);
  isParamScriptGenerating = false;

  // we need to run an addToCart with the newly received calculations from the designer...
  // this may happen if the user modifies the dimensions and immediatelly presses add to cart
  // the result wasn't done then, so we just set a flag to true to make the add to cart later on...
  if(addToCartFlag == true) {
    addToSessionCart();
  }  
};

(window as UCWindow).UCOnLoadedReceived = function() {
  console.log("UCOnLoadedReceived, setting script and parameters");
  setScript();
  setParameters();
  fitToScreen();
};

const uconScriptFetcher: Fetcher = new Fetcher(PrestaGlobals.virtualUri + "/scripts?id_product=" + PrestaGlobals.productId);
const paramScriptFetcher: Fetcher<IParamScriptsRule[]> = new Fetcher<IParamScriptsRule[]>(PrestaGlobals.virtualUri + "/params?id_product=" + PrestaGlobals.productId
  + "&id_shop=" + PrestaGlobals.shopId
  + "&id_cart=" + PrestaGlobals.cartId
  + "&id_customer=" + PrestaGlobals.customerId);

// assign global variables
//document.querySelector<HTMLElement>('[data-id="cart-id"]')!.innerHTML = String(PrestaGlobals.cartId);

function showTabs(tabs: Set<string>): void {
  // first, hide all tab buttons
  // <div data-id="tab-buttons">
  // <button data-id="configuration-tab-button" ...
  
  const tabButtons: HTMLElement = document.querySelector<HTMLElement>('[data-id="tab-buttons"]')!;
  for (const tabButton of tabButtons.children) {
    tabButton.classList.add("hidden");
  }

  // then, show only the ones that are in the tabs array
  for (const tab of tabs) {
    const tabButton: HTMLButtonElement = document.querySelector<HTMLButtonElement>('[data-id="' + tab + '-tab-button"]')!;
    tabButton.classList.remove("hidden");
  }

  document.querySelector<HTMLElement>(".tablinks")!.click();
}

// fetch and wait for all data to be processed
Promise.all([Boards.instance!.request(), Edges.instance!.request(), Catalog.instance!.request(), uconScriptFetcher.request(), paramScriptFetcher.request()])
  .then(() => {

      ajax_getSessionCartSession();

    if (paramScriptFetcher.Result == null) {
      console.error("paramScriptFetcher.Result is null!");
      return;
    }

    paramScripts = paramScriptFetcher.Result;
    preParseParamScripts();
    
    paramScriptProc = new ParamScriptsProcessor(paramScripts, setParameters);
    showTabs(paramScriptProc.usedTabs);

    uconScript = uconScriptFetcher.Result;
    updateUIWithScript();

    if(Catalog.instance != null) {
        Catalog.instance.children().forEach((catalogItem) => {
            if(Array.isArray(catalogItem.features) && catalogItem.features.length == 0) {
                console.log("Item doesn't have features, skipping...");
                return;
            }

            const template: HTMLElement = templates.querySelector<HTMLElement>('[data-id="CatalogItem"]')!;
            const cloned: HTMLElement = template.cloneNode(true) as HTMLElement;

            const target: HTMLElement = catalog.querySelector<HTMLElement>('[data-id="items"]')!;
            
            cloned.querySelector<HTMLImageElement>('img')!.src = catalogItem.Image;
            cloned.querySelector<HTMLElement>('[data-id="name"]')!.innerHTML = catalogItem.Name;

            cloned.addEventListener("click", (event: MouseEvent) => {
                updateProductCookie(catalogItem.ID);

                // clean up the configuration container
                const configurationContainer: HTMLElement = document.querySelector<HTMLElement>('[data-id="configuration"]')!;
                while (configurationContainer.firstChild) {
                    configurationContainer.removeChild(configurationContainer.firstChild);
                }

                // clean up the material container
                const materialContainer: HTMLElement = document.querySelector<HTMLElement>('[data-id="material"]')!;
                while (materialContainer.firstChild) {
                    materialContainer.removeChild(materialContainer.firstChild);
                }

                PrestaGlobals.productName = catalogItem.Name;

                uconScriptFetcher.init(PrestaGlobals.virtualUri + "/scripts?id_product=" + catalogItem.ID);
                paramScriptFetcher.init(PrestaGlobals.virtualUri + "/params?id_product=" + catalogItem.ID
                    + "&id_shop=" + PrestaGlobals.shopId
                    + "&id_cart=" + PrestaGlobals.cartId
                    + "&id_customer=" + PrestaGlobals.customerId);

                Promise.all([uconScriptFetcher.request(), paramScriptFetcher.request()])
                .then(() => {
                    if (uconScriptFetcher.Result == null) {
                        console.error("uconScriptFetcher.Result is null!");
                        return;
                    }

                    if (paramScriptFetcher.Result == null) {
                        console.error("paramScriptFetcher.Result is null!");
                        return;
                    }

                    // handle paramScripts first, because these will be added to to UI first
                    paramScripts = paramScriptFetcher.Result;
                    preParseParamScripts();

                    paramScriptProc = new ParamScriptsProcessor(paramScripts, setParameters);
                    showTabs(paramScriptProc.usedTabs);

                    // handle uconScript later, because this will be added to the UI last
                    uconScript = uconScriptFetcher.Result;
                    updateUIWithScript();
                    
                    closeCatalog();

                    setTimeout(() => {
                        setScript();
                        setParameters();
                    }, 500);

                });

            }); // img click
        
            target.appendChild(cloned);
        }); // forEach
    } // if

  })
  .catch((error: any) => {
    console.log("Error: " + error);
    alert("Error while waiting for promise all:\n" + error);
  });
